import React from 'react';
import { List } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/list.less';

export default List;
